import * as React from 'react';
import styled from 'styled-components';
import AngleRight from '../components/AngleRight';
import { Link } from 'gatsby';

const Article = styled.article`
	text-align: center;
	position: relative;

	h3 {
		font-size: 18px;
	}

	& a.fullBox {
		position: absolute;
		width: 100%;
		left: 0;
		top: 0;
		padding-top: 172px;
		padding-bottom: 110px;
		white-space: nowrap;
		line-height: 20px;
		height: 20px;
	}

	& svg.icon {
		margin-bottom: 35px;
	}
`;

const ProductBox = (props: any) => (
	<Article className='product-box rounded-box col-12 col-md-6 col-lg-4' style={{maxWidth: `325px`}}>
		{props.icon}
		<h3>
			<Link
				to={props.productLink}
				className={`fullBox animate-right ${props.product} productsPage`}
			>
				{props.product}<AngleRight />
			</Link></h3>
		<p>{props.productOneLiner}</p>
	</Article>
);

export default ProductBox;
